import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the view for cost center table.
 * @extends JetView
 */
export default class tableCostCenterView extends JetView {
    /**
     * Configures the datatable and its properties.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this; // Reference to the current instance

        return {
            view: 'datatable',
            id: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: screen.width < 820 ? false : true, // Conditional scrolling based on screen width
            columns: [
                {
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Editar', // Tooltip for edit action
                    template: function (obj) {
                        // Conditional rendering of edit icon based on permissions
                        if (devConfig.getPermAction('accountingAreaEdit', 'Edit')) {
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            return '';
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 60, sort: 'int' },
                { id: 'Name', header: _('Nombre'), width: 150, sort: 'int' },
                {
                    id: 'Employees',
                    header: _('Encargado'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
            ],
            onClick: {
                edit: function (euv, id) {
                    // Trigger event to open edit form
                    vthis.app.callEvent('openEdit', [{}]);
                },
            },
            tooltip: true,
            math: true,
            loadahead: devConfig.getDefaultDataFetch(), // Fetch data ahead of time
            pager: 'pagerA',
            url: devConfig.geturlApi() + 'Accounting/GetAreas', // API endpoint for data
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        var url = grid.data.url; // Store the URL for data fetching
        var filter = ''; // Initialize filter variable
        var datePopup = []; // Array to hold employee data for popup
        var popup = ''; // Variable for edit popup
        var popupAdd = ''; // Variable for add popup

        // Fetch employee data for dropdown
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetEmployeesSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    if (!resp.HasError && resp.Data !== null) {
                        datePopup = resp.Data; // Store employee data
                        // Create edit popup
                        popup = webix.ui({
                            view: 'window',
                            id: 'EditArea',
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: _('Editar Área') },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close',
                                        click: function () {
                                            this.getTopParentView().hide(); // Close popup
                                        },
                                    },
                                ],
                            },
                            position: 'center',
                            modal: true,
                            body: {
                                view: 'form',
                                id: 'editForm',
                                elements: [
                                    {
                                        view: 'text',
                                        label: 'ID',
                                        name: 'Id',
                                        readonly: true, // ID field is read-only
                                    },
                                    {
                                        view: 'text',
                                        label: _('Nombre'),
                                        name: 'Name',
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Encargado'),
                                        name: 'Employees',
                                        readonly: true, // Employees field is read-only
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'),
                                        name: 'State',
                                        options: [
                                            { id: 'A', value: _('Activado') },
                                            { id: 'I', value: _('Inactivado') },
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'),
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close popup on cancel
                                                    $$('editForm').setValues(
                                                        $$('editForm').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    var values = $$('editForm').getValues(); // Get form values
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Accounting/Areas',
                                                            '{"Id":"' +
                                                                values.Id +
                                                                '", "Name":"' +
                                                                values.Name +
                                                                '", "Employees":"' +
                                                                values.Employees +
                                                                '", "State":"' +
                                                                values.State +
                                                                '"}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(_('Error! ')); // Error message on failure
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(_('Área Actualizado')); // Success message
                                                                    grid.clearAll(); // Clear grid data
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter,
                                                                    ); // Reload grid data
                                                                },
                                                            },
                                                        );
                                                    $$('editForm').setValues(
                                                        $$('editForm').getCleanValues(), // Reset form values
                                                    );
                                                    this.getTopParentView().hide(); // Close popup
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        });
                        // Create add popup
                        popupAdd = webix.ui({
                            view: 'window',
                            id: 'AddArea',
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: _('Añadir Área') },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close',
                                        click: function () {
                                            this.getTopParentView().hide(); // Close popup
                                        },
                                    },
                                ],
                            },
                            position: 'center',
                            modal: true,
                            body: {
                                view: 'form',
                                id: 'addformArea',
                                elements: [
                                    {
                                        view: 'text',
                                        label: _('Nombre'),
                                        name: 'Name',
                                        required: true, // Name field is required
                                        labelWidth: 100,
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Encargado'),
                                        name: 'Employees',
                                        labelWidth: 100,
                                        options: datePopup, // Populate options with employee data
                                        required: false,
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'),
                                        name: 'State',
                                        labelWidth: 100,
                                        options: [
                                            { id: 'A', value: _('Activado') },
                                            { id: 'I', value: _('Inactivado') },
                                        ],
                                        required: true, // State field is required
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'),
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close popup on cancel
                                                    $$('addformArea').setValues(
                                                        $$('addformArea').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    var values = $$('addformArea').getValues(); // Get form values
                                                    if ($$('addformArea').validate()) {
                                                        // Validate form
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'Accounting/SaveArea',
                                                                '{"Name":"' +
                                                                    values.Name +
                                                                    '", "Employees":"' +
                                                                    values.Employees +
                                                                    '", "State":"' +
                                                                    values.State +
                                                                    '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(_('Error! ')); // Error message on failure
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        webix.message(_('Área Agregado')); // Success message
                                                                        grid.clearAll(); // Clear grid data
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter,
                                                                        ); // Reload grid data
                                                                    },
                                                                },
                                                            );
                                                        $$('addformArea').setValues(
                                                            $$('addformArea').getCleanValues(), // Reset form values
                                                        );
                                                        this.getTopParentView().hide(); // Close popup
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _('Completa los campos...'), // Validation error message
                                                        });
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                                elementsConfig: {
                                    on: {
                                        onChange: function () {
                                            this.validate(); // Validate on change
                                        },
                                    },
                                },
                            },
                        });
                        $$('editForm').bind($$('datatable')); // Bind edit form to datatable
                    }
                },
            });

        // Event handler for filtering data
        this.on(this.app, 'area:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload grid data with filters
            filter = string1; // Update filter variable
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });

        // Event handler for adding a new area
        this.on(this.app, 'addArea:button', (filter) => {
            if (datePopup.length > 0) {
                $$('addformArea').clearValidation(); // Clear validation errors
                popupAdd.show(); // Show add popup
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message if data not loaded
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        // Event handler for opening the edit form
        this.on(this.app, 'openEdit', (filterData) => {
            if (datePopup.length > 0) {
                popup.show(); // Show edit popup
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message if data not loaded
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
